var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "col-12 no-padding" }, [
    _c(
      "div",
      { staticClass: "col-md-12 no-padding" },
      [
        _c("section-header", {
          attrs: { title: _vm.$t("apps.accounting.message.journalsetdefault") }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              {
                staticClass: "col-md-12 no-padding",
                staticStyle: { height: "24px" }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("apps.accounting.message.journalautoopen")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group col-12 mb-0",
                staticStyle: { padding: "0" }
              },
              [
                _c("div", { staticClass: "form-row no-padding no-margin" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group col-6",
                      staticStyle: { padding: "0" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "box-input",
                          staticStyle: { "border-radius": "0" }
                        },
                        [
                          _c(
                            "vs-checkbox",
                            {
                              staticStyle: {
                                float: "left",
                                position: "relative",
                                top: "1px",
                                left: "-5px"
                              },
                              attrs: { color: "#A3CA76" },
                              model: {
                                value:
                                  _vm.form.journal.entry_auto_open.is_active,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.journal.entry_auto_open,
                                    "is_active",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.journal.entry_auto_open.is_active"
                              }
                            },
                            [
                              !_vm.form.journal.entry_auto_open.is_active
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("message.disabled")))
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("message.enabled")))
                                  ])
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group col-6",
                      staticStyle: { "padding-left": "0", "padding-right": "0" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "box-input active",
                          staticStyle: {
                            "border-radius": "0px .25rem .25rem 0",
                            "border-left": "0",
                            padding: "0",
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c("BaseDropdown", {
                            staticClass: "select-inside",
                            attrs: { options: _vm.autoOpenRepeatTypes },
                            model: {
                              value:
                                _vm.form.journal.entry_auto_open.repeat.type,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.journal.entry_auto_open.repeat,
                                  "type",
                                  $$v
                                )
                              },
                              expression:
                                "form.journal.entry_auto_open.repeat.type"
                            }
                          }),
                          _vm._v(" "),
                          ["every_month"].includes(
                            _vm.form.journal.entry_auto_open.repeat.type
                          )
                            ? _c("BaseDropdown", {
                                staticClass: "select-inside",
                                attrs: { options: _vm.dayOptions },
                                model: {
                                  value:
                                    _vm.form.journal.entry_auto_open.repeat.day,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.journal.entry_auto_open.repeat,
                                      "day",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.journal.entry_auto_open.repeat.day"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          ["every_month", "every_day"].includes(
                            _vm.form.journal.entry_auto_open.repeat.type
                          )
                            ? _c("BaseDropdown", {
                                staticClass: "select-inside",
                                attrs: { options: _vm.timeOptions },
                                model: {
                                  value:
                                    _vm.form.journal.entry_auto_open.repeat
                                      .time,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.journal.entry_auto_open.repeat,
                                      "time",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.journal.entry_auto_open.repeat.time"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-md-6 col-lg-3" }, [
                _c(
                  "div",
                  { staticClass: "form-group", staticStyle: { padding: "0" } },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "apps.accounting.message.journalautoopendefaultstatus"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("BaseDropdown", {
                      attrs: { options: _vm.statusOptions },
                      model: {
                        value: _vm.form.journal.entry_auto_open.default_status,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form.journal.entry_auto_open,
                            "default_status",
                            $$v
                          )
                        },
                        expression:
                          "form.journal.entry_auto_open.default_status"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-md-6 col-lg-3" }, [
                _c(
                  "div",
                  { staticClass: "form-group", staticStyle: { padding: "0" } },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "apps.accounting.message.journalmanualdefaultstatus"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("BaseDropdown", {
                      attrs: { options: _vm.statusOptions },
                      model: {
                        value: _vm.form.journal.entry_manual.default_status,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form.journal.entry_manual,
                            "default_status",
                            $$v
                          )
                        },
                        expression: "form.journal.entry_manual.default_status"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed57f1b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed57f1b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/FormSetDefaultJournal.vue
// module id = null
// module chunks = 